module.exports = __webpack_public_path__ + "static/media/la-yogi.d23bc957.jpg";